import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLazySelector } from 'hooks'
import { UserDeclaration } from 'core/userDeclaration/components'
import { EndUserDeclarationModal } from 'modules/simulatorTrainings/common/components'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import {
  loadUserDeclarationConfirmation,
  confirmEndUserDeclaration,
} from 'modules/simulatorTrainings/common/slices/endUserDeclaration'

const I18_PATH = `${namespace}:simulatorTraining.endUserDeclaration`

const EndUserDeclarationLayer: React.FC = ({ children }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    endUserDeclarationText = '',
    isModalOpen,
    error,
  } = useLazySelector(({ simulatorTrainingEndUserDeclaration }) => {
    const { userDeclarationConfirmationData, userDeclarationData, isModalOpen } =
      simulatorTrainingEndUserDeclaration
    return {
      error: userDeclarationConfirmationData.error || userDeclarationData.error,
      endUserDeclarationText: userDeclarationData.result?.details.endUserDeclarationText,
      isModalOpen,
    }
  })

  useEffect(() => {
    dispatch(loadUserDeclarationConfirmation())
  }, [dispatch])

  function handleAcceptance() {
    dispatch(confirmEndUserDeclaration())
  }

  function renderModal() {
    if (error) return null

    return (
      <EndUserDeclarationModal title={t(`${I18_PATH}.title`)} isOpen={isModalOpen}>
        <UserDeclaration
          endUserDeclarationText={endUserDeclarationText}
          onAcceptance={handleAcceptance}
        />
      </EndUserDeclarationModal>
    )
  }

  return (
    <>
      {renderModal()}
      {children}
    </>
  )
}

export default EndUserDeclarationLayer
